export default __webpack_public_path__ + "static/media/inu.3c57a970.png";